import React, { useState } from 'react'
import { Image, UL } from '../../AbstractElements'
import { InboxEmailType } from '../../types/common-elements/CommonElementsTypes';
import { Card, CardBody } from 'reactstrap';
export const inboxEmailData: InboxEmailType[] = [
    {
      id: 1,
     
      name: "Marvin McKinney",
      color: "primary",
      message: "New comments on MSR2024 draft presentation -",
      subMessage:
        "craft beer labore wes anderson cred nesciunt sapiente ea proident...",
      badge: [
        {
          title: "new",
          color: "primary",
        },
      ],
      time: "2:30 AM",
      star: false,
    },
    {
      id: 2,
      image: "3.png",
      name: "Brooklyn Simmons",
      color: "primary",
      message: "Confirm your booking id -",
      subMessage:
        "Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.",
      badge: [
        {
          title: "deadline",
          color: "primary",
        },
      ],
      time: "7:50 AM",
      star: false,
    },
    {
      id: 3,
      shortName: "EH",
      name: "Esther Howard",
      color: "primary",
      message: "Confirm your booking id -",
      subMessage:
        "craft beer labore wes anderson cred nesciunt sapiente ea proident...",
      badge: [
        {
          title: "work",
          color: "success",
        },
      ],
      time: "1:00 PM",
      star: false,
    },
    {
      id: 4,
      shortName: "CW",
      name: "Cameron Williamson",
      color: "primary",
      message: "Very fiction Link -",
      subMessage:
        "Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.",
      time: "5 Day ago",
      star: false,
    },
    {
      id: 5,
   
      name: "Ronald Richards",
      color: "primary",
      message: "Confirm your booking id -",
      subMessage:
        "craft beer labore wes anderson cred nesciunt sapiente ea proident - Samsa was a travelling",
      badge: [
        {
          title: "Update.Zip",
          color: "warning",
        },
      ],
      time: "7 April",
      star: false,
    },
    {
      id: 6,
      image: "10.jpg",
      name: "Darlene Robertson",
      color: "primary",
      message: "Confirm your booking id -",
      subMessage:
        "Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda ...",
      badge: [
        {
          title: "Import File..",
          color: "warning",
        },
      ],
      time: "04 April",
      star: false,
    },
    {
      id: 7,
      image: "12.png",
      name: "Jacob Jones",
      color: "primary",
      message: "Welcome to our new office -",
      subMessage:
        "craft beer labore wes anderson cred nesciunt sapiente ea proident...",
      time: "01 April",
      star: false,
    },
    {
      id: 8,
      image: "dashboard-8/linnk_logo.png",
      name: "Ralph Edwards",
      color: "primary",
      message: "Your Order #224820098 has been Confirmed-",
      subMessage:
        "A collection of textile samples lay spread out on the table...",
      time: "1:00 PM",
      star: false,
    },
    {
      id: 9,
      image: "dashboard-8/linnk_logo.png",
      name: "Darlene Robertson",
      color: "primary",
      message: "Confirm your booking id -",
      subMessage:
        "Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda ...",
      badge: [
        {
          title: "Import File..",
          color: "danger",
        },
      ],
      time: "04 April",
      star: false,
    },
    {
      id: 10,
      shortName: "EH",
      name: "Esther Howard",
      color: "primary",
      message: "Confirm your booking id -",
      subMessage:
        "craft beer labore wes anderson cred nesciunt sapiente ea proident...",
      badge: [
        {
          title: "work",
          color: "success",
        },
      ],
      time: "1:00 PM",
      star: false,
    },
    {
      id: 11,
      image: "dashboard-8/linnk_logo.png",
      name: "Marvin McKinney",
      color: "primary",
      message: "New comments on MSR2024 draft presentation -",
      subMessage:
        "craft beer labore wes anderson cred nesciunt sapiente ea proident...",
      badge: [
        {
          title: "new",
          color: "primary",
        },
      ],
      time: "2:30 AM",
      star: false,
    },
    {
      id: 12,
      shortName: "CW",
      name: "Cameron Williamson",
      color: "primary",
      message: "Very fiction Link -",
      subMessage:
        "Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.",
      time: "5 Day ago",
      star: false,
    },
  ];
 
function ViewAllNotification() {
 
 
  return (
 
       
    <div className="page-body p-3">
      <Card className="shadow-sm rounded-3">
        <div className="card-header bg-primary text-white fw-bold">
          Notifications
        </div>
        <CardBody className="p-4">
          <ul className="list-group list-group-flush">
            {inboxEmailData.map((email) => (
              <li
                key={email.id}
                className="list-group-item d-flex align-items-center gap-3 pb-4"
              >
                {/* Avatar or Short Name */}
                {email.image ? (
                  <Image
                    src={`/path-to-images/${email.image}`}
                    alt={email.name}
                    className="rounded-circle"
                    style={{ width: '45px', height: '45px', objectFit: 'cover' }}
                  />
                ) : (
                  <div
                    className={`rounded-circle bg-${email.color} text-white d-flex align-items-center justify-content-center`}
                    style={{ width: '45px', height: '45px', fontWeight: 'bold' }}
                  >
                    {email.shortName}
                  </div>
                )}
 
                {/* Content */}
                <div className="flex-grow-1">
                  <div className="fw-semibold">{email.name}</div>
                  <div className="text-dark">{email.message}</div>
                  <div className="small text-muted">{email.subMessage}</div>
                  {email.badge?.map((b, i) => (
                    <span
                      key={i}
                      className={`badge bg-${b.color} me-1 mt-1`}
                      style={{ fontSize: '0.7rem' }}
                    >
                      {b.title}
                    </span>
                  ))}
                </div>
 
                {/* Actions */}
                <div className="d-flex flex-column align-items-end text-end gap-2">
                  <small className="text-muted">{email.time}</small>
                  <div className="d-flex gap-2">
                   
                    <i className="fa fa-trash-o" style={{ cursor: 'pointer' }}></i>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </CardBody>
      </Card>
    </div>
 
  )
}
 
export default ViewAllNotification